import { CommApiInstance } from "Utils/CommApiInstance";




const MembAddrRegApi = async (
    zipCode:string,
    roadAddr:string,
    detailAddr:string,
) => {
    return await CommApiInstance.post("memb/addr/reg",{
        apiBody:{
            zipCode: zipCode,
            addr1: roadAddr,
            addr2: detailAddr,
        },
    })
    .then((Resp) => Resp.data);
}
export default MembAddrRegApi;